/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

//  Font --> Google Fonts
// import "typeface-montserrat"
import "typeface-pt-serif"
